<div class="panelbar-wrapper" [hidden]="isHidden">
  <kendo-panelbar [expandMode]="expandMode" [items]="infoJour">
    <ng-template kendoPanelBarItemTemplate let-dataItem>
      <ags-info-session
        [detail]="dataItem.content"
        (demandesOutput)="getDemandes($event)"
        (goToDetailOutput)="changeRoute($event)"
      ></ags-info-session>
      <ags-info-indispo 
        [detail]="dataItem.content" 
        *ngIf="dataItem.content.type === 'indispo'"
      ></ags-info-indispo>
      <ags-info-encadrement
        [detail]="dataItem.content"
        *ngIf="dataItem.content.type === 'encadrement'"
        (goToDetailOutput)="changeRoute($event)"
      ></ags-info-encadrement>
    </ng-template>
  </kendo-panelbar>
</div>

<!--Loader temporaire -->
<div class="panelbar-wrapper" uk-spinner *ngIf="isHidden"></div>
<!--<lib-ags-loading *ngIf="isHidden"></lib-ags-loading>-->
